/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Lustrace_Status_HitInputs */

const cs_property_lustrace_status_hit = /** @type {(inputs: Property_Lustrace_Status_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nález`)
};

const en_property_lustrace_status_hit = /** @type {(inputs: Property_Lustrace_Status_HitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hit`)
};

/**
* | output |
* | --- |
* | "Hit" |
*
* @param {Property_Lustrace_Status_HitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_lustrace_status_hit = /** @type {((inputs?: Property_Lustrace_Status_HitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Lustrace_Status_HitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_lustrace_status_hit(inputs)
	return cs_property_lustrace_status_hit(inputs)
});